////////LIBRARY/////////
import { applyMiddleware, createStore, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
///////COMPONENTS///////
import reducer from './reducers'
import rootSaga from './sagas'

export default function configureStore(initialState) {
	const sagaMiddleware = createSagaMiddleware()

	// check env variable if in production active redux dev tool if not disable it
	// env variable are 'development' or 'production'
	const store = createStore(
		reducer,
		compose(
			applyMiddleware(sagaMiddleware),
			process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__
				? window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true, traceLimit: 25 })
				: (f) => f
		)
	)

	sagaMiddleware.run(rootSaga)

	return store
}
